module.exports = __webpack_public_path__ + "static/img/sx_wtg.44d842a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sx_wtg.png
// module id = SUWu
// module chunks = 167